import React, { useEffect, useState } from "react";
import { withSnackbar } from "notistack";

import Loader from "components/Custom/Loader";
import ExcelGrid from "components/Custom/ExcelGrid";

import { LABELS, TITLES } from "common/lables";
import { CRM_REPORTS_APIs } from "apihandlers/crm/reports";

const LeadVisits = (props: any) => {
  const { setDashMenu } = props;

  const [loading, setLoading] = useState(true);
  const [rows, setRows] = useState<any>(null);

  useEffect(() => {
    if (loading) {
      getRows();
    }
  }, [loading]);

  const getRows = async () => {
    try {
      const args = {
        // fromDate: DateFunctions.getDate("thismonth", "from", FORMATS.SQL_DATE),
        // toDate: DateFunctions.getDate("thismonth", "from", FORMATS.SQL_DATE),
        fromDate: "2023-06-01",
        toDate: "2023-06-30",
      };
      const res: any = await CRM_REPORTS_APIs.getLeadVisits(args);
      const { status, response } = res;
      if (status === 200) {
        let list = response.records;
        setRows(list);
        setLoading(false);
      }
    } catch (error) {
      console.error("getLeadVisits:", error);
    }
  };

  const COLUMNS = [
    {
      key: "crmLeadName",
      name: "Lead Name",
      width: "30%",
      type: "text",
      sortable: true,
      searchable: true,
      editable: false,
    },
    {
      key: "leadSource",
      name: "Lead Source",
      width: "15%",
      type: "text",
      sortable: true,
      searchable: true,
      editable: false,
    },
    {
      key: "createdOn",
      name: "Created On",
      width: "10%",
      type: "text",
      sortable: true,
      searchable: true,
      editable: false,
    },
    {
      key: "mobileNo",
      name: "Mobile No.",
      width: "10%",
      type: "text",
      sortable: true,
      searchable: true,
      editable: false,
    },
    {
      key: "leadStatus",
      name: "Lead Status",
      width: "15%",
      type: "dropdown",
      sortable: true,
      searchable: true,
      editable: false,
      filters: [
        {
          id: "Customer",
          name: "Customer",
        },
        {
          id: "Dealer",
          name: "Dealer",
        },
      ],
    },
    {
      key: "fssiNumber",
      name: "FSSAI",
      width: "10%",
      type: "text",
      sortable: true,
      searchable: true,
      editable: false,
    },
    {
      key: "fssiDate",
      name: "FSSAI Expiry",
      width: "10%",
      type: "text",
      sortable: true,
      searchable: true,
      editable: false,
    },
  ];

  const reloadGrid = () => {
    setRows(null);
    getRows();
  };

  console.log("selectedRow", rows);

  return (
    <React.Fragment>
      <div className="pageInfo">
        <ul className="breadcrumbs">
          <li>{LABELS.HOME}</li>
          <li className="dim">{" / "}</li>
          <li onClick={() => setDashMenu(LABELS.HOME)}>{TITLES.CRM_REPORTS}</li>
          <li className="dim">{" / "}</li>
          <li className="active">{TITLES.LEAD_VISITS}</li>
        </ul>
        <h4>{TITLES.LEAD_VISITS}</h4>
        {/* <p>{SUB_TITLES.LEAD_VISITS}</p> */}
      </div>

      <div className="grid excelGridWrapper">
        {rows ? (
          <ExcelGrid
            height={window.innerHeight * 0.85}
            cols={COLUMNS}
            rows={rows}
            exportOption={true}
            newRowOption={false}
            exportName={TITLES.LEAD_VISITS}
            onReload={reloadGrid}
          />
        ) : (
          <div className="flexRowCenter">
            <Loader />
          </div>
        )}
      </div>
    </React.Fragment>
  );
};

export default withSnackbar(LeadVisits);
